module.exports = __webpack_public_path__ + "static/media/mens_fashion.284111e2.jpg";